const currentDomain = document.domain;

if (currentDomain.indexOf('insider') !== -1) {
  const $custLoginFooter = $('div').find('[data-ody-id="cust-login-footer"]');
  const $custRegistrationFooter = $('div').find('[data-ody-id="cust-registration-footer"]');
  if ($custLoginFooter !== undefined) {
    $custLoginFooter.html('<p id="insiderClubDisclaimer"><span id="insiderIntroNotice">NOTICE:</span> Registration and membership in our <em>Insider\'s Club</em> is prohibited without exception for travel agents, cruise line personnel and cruise brokers.</p>');
  }

  if ($custRegistrationFooter !== undefined) {
    $custRegistrationFooter.html('<p id="insiderClubDisclaimer"><span id="insiderIntroNotice">NOTICE:</span> Registration and membership in our <em>Insider\'s Club</em> is prohibited without exception for travel agents, cruise line personnel and cruise brokers.</p>');
  }
}
